
import { Pagination, Stack, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { MensajeAlertaDanger, TooltipAndIcon } from "../../components";
import { LayoutTabla } from "../../layouts";
import { useInventarioStore, useModalStore } from "../../../stores";
import { useNavigate } from "react-router-dom";
import { separadorMillares, useValidarRoles } from "../../../hooks";


const paginado = Number(process.env.REACT_APP_PAGINADO);



export const TablaInventarios = ({ data, chagePage=() => {}, page=0, }) => {


    const navigate = useNavigate();
    const { permitirXRol } = useValidarRoles();
    const isAdmin = permitirXRol('SUPERADMIN');
    const { totalInventario, setActivarInventario } = useInventarioStore();
    const { modalFormToggle } = useModalStore();

    
    const handleVerInventario = (url, id) => {
        navigate(`/super/${url}/${id}`)
    }


    const handleEditar = (valor, tipo) => {
        setActivarInventario(valor)
        modalFormToggle(true, tipo);
    }



    return (
        <>
        {(data.length > 0)
        ?   <LayoutTabla
                paginado={
                <Stack sx={{ py:2, display:'flex', justifyContent:'center', alignItems:'center' }}>
                    <Pagination count={Math.ceil(totalInventario / +paginado)} disabled={Math.ceil(totalInventario / +paginado) === 1}
                        variant="outlined" page={page + 1} color="primary" 
                        onChange={ (_, newValor) => chagePage(newValor) } 
                    />
                </Stack>
            }>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{width:'25%'}}>Producto</TableCell>
                        <TableCell sx={{width:'15%'}}>Cantidad</TableCell>
                        {(isAdmin) &&
                        <>
                        <TableCell sx={{width:'15%'}}>Valorización</TableCell>
                        <TableCell sx={{width:'15%'}}>Proveedores</TableCell>
                        </>
                        }
                        <TableCell sx={{width:'15%'}}>UnidadMedida</TableCell>
                        <TableCell sx={{width:'17%'}}>Acciones</TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    {data.map( ( a ) => (
                        <TableRow  key={ a._id }>
                            <TableCell>{ a.nombre }</TableCell>
                            <TableCell>{ a.cantidad }</TableCell> 
                            {(isAdmin) &&
                            <>
                            <TableCell>{ `$${separadorMillares(a.valorInventario)}` }</TableCell>
                            <TableCell>{`${a?.proveedores.length}`}</TableCell>
                            </>
                            }
                            <TableCell>
                                {(a.medida) 
                                ? a.medida.nombre 
                                :<Typography variant="span" color='error'>No-Dato</Typography> }
                            </TableCell>
                            <TableCell>
                                <Stack direction="row" spacing={1} justifyContent="center">
                                    {(isAdmin) &&
                                    <>
                                    <TooltipAndIcon
                                        titulo="Editar Stock"
                                        icono="editar"
                                        color="white"
                                        onClick={ () => handleEditar(a, 'crear-stock') }
                                    />  

                                    <TooltipAndIcon
                                        titulo="Ver Lotes"
                                        icono="lotes"
                                        color="white"
                                        onClick={ () => handleVerInventario('lotes', a._id) }
                                    />  
                                    </>
                                    }
                                    
                                    <TooltipAndIcon
                                        titulo="Historial Movimientos"
                                        icono="ver"
                                        color="white"
                                        onClick={ () => handleVerInventario('reportes', a._id) }
                                    />  

                                    <TooltipAndIcon
                                        titulo="Salida de Stock"
                                        icono="salida"
                                        color="white"
                                        onClick={ () => handleEditar(a, 'salida-stock') }
                                    />  

                                </Stack>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </LayoutTabla>
        
        :   <MensajeAlertaDanger titulo='No hay stock de productos disponible...' />
        }
        </>
    )
}